import { render, staticRenderFns } from "./tagsPopup.vue?vue&type=template&id=cb5807ea&scoped=true&"
import script from "./tagsPopup.vue?vue&type=script&lang=js&"
export * from "./tagsPopup.vue?vue&type=script&lang=js&"
import style0 from "./tagsPopup.vue?vue&type=style&index=0&id=cb5807ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5807ea",
  null
  
)

export default component.exports